module.exports = __webpack_public_path__ + "img/Nofigure.bebc3eb1.png";